<fieldset>
  <label [raskRequired]="required">
    {{label}}
    @if (infoText) {
      <rask-info>{{infoText}}</rask-info>
    }
  </label>
  <textarea
    [ngClass]="{'readonly': readonly}"
    id="{{aid}}"
    [(ngModel)]="value"
    [ngModelOptions]="{standalone: true}"
    [placeholder]="placeholder"
    [attr.rows]="rows > 0 ? rows : null"
    [attr.maxlength]="maxlength"
    [disabled]="disabled || readonly"
    type="text">
  </textarea>
  @if (maxlength > 0) {
    <div class="textarea-chars">
      <span class="remaining">{{texts.charsLeft | raskStringFormat : charsLeft}}</span>
    </div>
  }
  @if (rule) {
    <rask-validation-message [rule]="rule"></rask-validation-message>
  }
</fieldset>
